import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const getPrayersByOrg = (id) => {
    let reqid=id
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const token=getTokenfromUserObj()
    useEffect(() => {
        const getPrayers = async (id) => {
          try {
            const res = await axios.get(`${app.URL}/prayertime/viewbyorg/${id}`,{headers:{auth:token}});
            console.log(res);
            setResponse(res.data);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getPrayers(reqid);
      }, []);
    
      return { loading, response, error };
    };
export default getPrayersByOrg